import { Component } from '@angular/core';
import { OnBaseDocumentGroup } from '../../../../common/models/onBaseIntegrationAndMapping.model';
import { SelectorBase } from '../../groups/selector-base.component';



@Component({
    selector: 'onbase-program-area-document-group-permission-selector',
    templateUrl: "../../groups/selector-base.component.html",
    styleUrls: ['../../groups/selector-base.component.scss'],
    standalone: false
})
export class OnBaseProgramAreaDocumentGroupSelector extends SelectorBase<OnBaseDocumentGroup, OnBaseDocumentGroup> {

    compareElements(a: OnBaseDocumentGroup, b: OnBaseDocumentGroup): number {
        return a.name > b.name ? 1 : -1;
    }

    elementEqualsOutput(element: OnBaseDocumentGroup, output: OnBaseDocumentGroup): boolean {
        return output.id === element.id && output.name === element.name;
    }

    elementToOutput(element: OnBaseDocumentGroup): OnBaseDocumentGroup {
        return element;
    }

    getDisplay(element: OnBaseDocumentGroup): string {
        return element.name;
    }
}